import React from 'react';
import { Helmet } from 'react-helmet-async';

interface Props {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  preventToSearch?: boolean;
  ldJsonData?: string;
}

const HelmetComponent: React.FC<Props> = (props) => {
  const {
    title = '',
    description = '',
    ogTitle = '',
    ogDescription = '',
    ogImage = '',
    preventToSearch = false,
    ldJsonData,
  } = props;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {preventToSearch && <meta name="robots" content="noindex" />}
      {preventToSearch && <meta name="googlebot" content="noindex" />}
      {ldJsonData && <script type="application/ld+json">{ldJsonData}</script>}
    </Helmet>
  );
};

export default HelmetComponent;
